export enum HttpErrorStatus {
  NetworkError = 0,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  InternalServerError = 500,
}

export const DEFAULT_ERROR_MESSAGE = 'خطایی در سامانه رخ داده است';

export const HTTP_ERROR_MESSAGES: Partial<Record<HttpErrorStatus, string>> = {
  [HttpErrorStatus.NetworkError]: 'خطا در برقراری ارتباط با سرور.',
  [HttpErrorStatus.Unauthorized]: 'لطفا مجدد وارد حساب کاربری خود شوید.',
  [HttpErrorStatus.Forbidden]: 'متأسفانه شما اجازه دسترسی به این بخش را ندارید.',
  [HttpErrorStatus.NotFound]: 'منبع درخواستی یافت نشد.',
  [HttpErrorStatus.InternalServerError]: 'خطای سرور. لطفاً مجدداً تلاش کنید.',
};
